import * as React from "react";
import { IE2ETestableComponent } from "../../core/e2e/IE2ETestableComponent";
import { Wrapper } from "./components/Wrapper";

export interface ITitle extends IE2ETestableComponent {
  children?: any;
}

export const Title = ({ children, dataE2EId, ...props }: ITitle) => (
  <Wrapper {...props} data-e2e-id={dataE2EId}>
    {children}
  </Wrapper>
);
